import styled from 'styled-components';

export const InlineLogo = styled.div`
  height: 100%;
  width: 100%;
  padding: 0.5rem 1rem;
  box-sizing: border-box;

  img {
    max-width: 100%;
    max-height: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const FixedLogo = styled.div`
  position: fixed;
  bottom: 0;
  max-height: 200px;
  margin: 24px;
  > img {
    max-height: 55px;
    max-width: 220px;
  }
  @media (max-width: 1000px) {
    display: none;
  }
`;
